import React from 'react';
import { Outlet } from 'react-router-dom';

const PromotionsLayout: React.FC = () => {
  return <Outlet />;
};

export default PromotionsLayout;
